module.exports = __webpack_public_path__ + "assets/84164ffd492a7f5aba99dd9f383804b8.png";